// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3UN6G","modalFooterButton":"ModalNotes_modalFooterButton__94cM0"};